export const AUTH = {
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-button',
  loginToSignup: 'login-to-signup-link',
  signupName: 'signup-name-input',
  signupEmail: 'signup-email-input',
  signupPassword: 'signup-password-input',
  signupSubmit: 'signup-submit-button',
  signupToLogin: 'signup-to-login-link',
  logoutButton: 'logout-button',
};

export const NAV = {
  brand: 'nav-brand',
  dashboardLink: 'nav-dashboard-link',
  historyLink: 'nav-history-link',
  settingsLink: 'nav-settings-link',
};

export const DASH = {
  tabText: 'tab-text',
  tabFile: 'tab-file',
  tabUrl: 'tab-url',
  textInput: 'paste-text-input',
  fileInput: 'file-upload-input',
  fileExtractBtn: 'file-extract-button',
  urlInput: 'url-input',
  urlExtractBtn: 'url-extract-button',
  modelSelect: 'model-select',
  lengthSelect: 'length-select',
  formatSelect: 'format-select',
  languageSelect: 'language-select',
  summarizeBtn: 'summarize-submit-button',
  resultArea: 'summary-result',
  copyBtn: 'copy-summary-button',
  clearBtn: 'clear-input-button',
  charCount: 'character-count',
  modeSingleBtn: 'mode-single-button',
  modeChaptersBtn: 'mode-chapters-button',
  chaptersPreview: 'chapters-preview-indicator',
  chaptersResult: 'chapters-result-list',
  chapterItem: (i) => `chapter-item-${i}`,
  chapterTrigger: (i) => `chapter-trigger-${i}`,
};

export const HIST = {
  list: 'history-list',
  item: (id) => `history-item-${id}`,
  deleteItem: (id) => `history-delete-${id}`,
  searchInput: 'history-search',
  empty: 'history-empty',
};

export const DETAIL = {
  back: 'detail-back-button',
  toggleOriginal: 'detail-toggle-original',
  copy: 'detail-copy-button',
  delete: 'detail-delete-button',
  share: 'detail-share-button',
  shareLink: 'detail-share-link',
  copyShareLink: 'detail-share-copy-link',
};

export const PUBLIC = {
  page: 'public-summary-page',
  notFound: 'public-summary-not-found',
  copy: 'public-summary-copy',
  cta: 'public-summary-cta',
};

export const BILLING = {
  // Dashboard usage meter / banner
  banner: 'billing-banner',
  bannerUpgradeBtn: 'billing-banner-upgrade-button',
  usageCounter: 'usage-counter',
  // Paywall (when free quota is reached) — full screen
  paywallScreen: 'paywall-screen',
  paywallUpgradeBtn: 'paywall-upgrade-button',
  twaNotice: 'billing-twa-notice',
  // Modal paywall (alt)
  paywallModal: 'billing-paywall-modal',
  paywallCheckoutBtn: 'billing-paywall-checkout',
  paywallClose: 'billing-paywall-close',
  // Settings upgrade button
  upgradeBtn: 'billing-upgrade-button',
  // Upgrade page
  upgradePage: 'billing-upgrade-page',
  upgradeCheckoutBtn: 'billing-upgrade-checkout-button',
  // Success page
  successScreen: 'billing-success-screen',
  successStatus: 'billing-success-status',
  successContinue: 'billing-success-continue',
  // Cancel page
  cancelScreen: 'billing-cancel-screen',
  cancelRetry: 'billing-cancel-retry',
  // Header / pro badge
  proBadge: 'pro-badge',
  // Promotional upgrade modal (10s after dashboard load, non-Pro only)
  promoModal: 'billing-promo-modal',
  promoModalClose: 'billing-promo-modal-close',
  promoModalCta: 'billing-promo-modal-cta',
  promoModalDismiss: 'billing-promo-modal-dismiss',
};

// ---------- Reading list ----------
export const READING_LIST = {
  page: 'reading-list-page',
  headerLink: 'nav-reading-list',
  addUrlBtn: 'reading-list-add-url-btn',
  addTextBtn: 'reading-list-add-text-btn',
  addForm: 'reading-list-add-form',
  addFormSubmit: 'reading-list-add-submit',
  emptyState: 'reading-list-empty',
  item: 'reading-list-item',
  itemSummarize: 'reading-list-summarize',
  itemDelete: 'reading-list-delete',
};
